/* eslint-disable */
const lesson = () =>
  import(/* webpackChunkName: "lesson" */ "./pages/lesson.vue");
const content = () =>
  import(/* webpackChunkName: "lesson" */ "./pages/content.vue");
const scene = () => import("./pages/scene-page.vue");
const chapter = () =>
  import(/* webpackChunkName: "read" */ "../textbook/pages/chapter");
// const catalog = () =>
//   import(/* webpackChunkName: "read" */ "../textbook/pages/catalog-modal.vue");
const read = () => import(/* webpackChunkName: "read" */ "./pages/read.vue");
// const collect = () => import("./pages/collect.vue");
// const work = () => import("./pages/work.vue");
// const collectIndex = () => import("../collect/pages/default.vue");
// const scaleIndex = () => import("../scale/pages/scale-index.vue");
// const scaleTest = () => import("../scale/pages/scale-test.vue");
// const scaleResult = ()=>import("../scale/pages/scale-result.vue")
// const signin = ()=>import("./pages/share-sign.vue")
const curtain = () => import("./pages/curtain.vue");

export default [
  {
    //今日课堂可用mock数据，/classroom/491/19/1?isclass=true&pid=19&classroom_id=491
    name: "classroom",
    path: "/classroom/:study/:classroom_id/:pid",
    component: lesson,
    children: [
      {
        path: "",
        name: "classroom-content",
        component: content,
        meta: {
          unsetTitle: true
        }
      },
      {
        path: "curtain/:resource_id/:pid",
        name: "curtain-page",
        component: curtain
      },
      {
        path: "scene/:resource_id/:pid",
        name: "scene-page",
        component: scene,
        meta: {
          selfShare: true
        }
      },
      // ,
      // {
      //   name: "work-page",
      //   path: "work",
      //   component: work,
      //   meta:{
      //     selfShare:true
      //   }
      // }
      // ,

      // {
      //   path: 'scale/:resource_id/:pid',
      //   name: "scale-page",
      //   component: scale,
      //   children: [
      //     {
      //       path: "index",
      //       name: "scale-index",
      //       component: scaleIndex
      //     }, {
      //       path: 'question',
      //       name: 'scale-test',
      //       component: scaleTest
      //     },{
      //       path:'result',
      //       name:'scale-result',
      //       component:scaleResult,
      //       meta:{
      //         selfShare:true
      //       }
      //     }
      //   ]
      // },
      // {
      //   path: "collect",
      //   name: "collect-page",
      //   component: collect,
      //   redirect: {
      //     name: "classroom-collect"
      //   },
      //   children: [
      //     {
      //       path: "",
      //       name: "classroom-collect",
      //       component: collectIndex
      //     }
      //   ]
      // },
      {
        name: "read-chapter",
        path: ":resource_id",
        component: read,
        children: [
          {
            path: "",
            name: "classroom-chapter",
            component: chapter
          }
          // {
          //   path: "catalog",
          //   name: "catalog",
          //   components: {
          //     default: chapter,
          //     catalog
          //   }
          // }
        ]
      }
    ]
  }
  // ,
  // {
  //   name:"classroom-sign",
  //   path:"/sign/share/:id",
  //   component:signin
  // }
];



// WEBPACK FOOTER //
// ./src/modules/min-lesson/routes.js